import {
  SET_ADDRESS_ALLOWED_TO_BUY_COINS,
  SET_ASYNC_COIN_BALANCE,
  SET_CONTRACT_ETHEREUM_BALANCE,
  SET_ETHEREUM_BALANCE,
  SET_IS_CONTRACT_OWNER,
  SET_TOTAL_SUPPLY
} from '../storage/AccountReducer';
import isContractInitialized from './ContractInitializationState';

export default class WalletInformationUpdaterService {
  init () {
    isContractInitialized() && this.initUpdating();
  }

  initUpdating () {
    this.updateValues();

    setInterval(() => this.updateValues(), 5000);
  }

  updateValues () {
    this.updateAsyncCoinBalance();
    this.updateTotalAsyncCoinSupply();
    this.updateEthereumBalance();
    this.checkIsOwner();
    this.getContractEthereumBalance();
    this.canBuyCoins();
  }

  updateAsyncCoinBalance () {
    window.contract
      .methods
      .balanceOf(Storage.getState().account.currentAccount)
      .call({from: Storage.getState().account.currentAccount}, (err, result) => {
        Storage.dispatch({type: SET_ASYNC_COIN_BALANCE, payload: +result});
      });
  }

  updateTotalAsyncCoinSupply () {
    window.contract
      .methods
      .totalSupply()
      .call({from: Storage.getState().account.currentAccount}, (err, result) => {
        Storage.dispatch({type: SET_TOTAL_SUPPLY, payload: result});
      });
  }

  updateEthereumBalance () {
    window.web3Service.eth
      .getBalance(Storage.getState().account.currentAccount, (error, result) => {
        if (error) {
          return;
        }

        let ethereumBalance = window.web3Service.utils.fromWei(result);

        Storage.dispatch({type: SET_ETHEREUM_BALANCE, payload: ethereumBalance});
      });
  }

  checkIsOwner () {
    window.contract
      .methods
      .isOwner()
      .call({from: Storage.getState().account.currentAccount}, (err, result) => {
        Storage.dispatch({type: SET_IS_CONTRACT_OWNER, payload: result});
      });
  }

  getContractEthereumBalance () {
    window.contract
      .methods
      .getContractEtherBalance()
      .call({from: Storage.getState().account.currentAccount}, (err, result) => {
        result = window.web3Service.utils.fromWei(result);
        Storage.dispatch({type: SET_CONTRACT_ETHEREUM_BALANCE, payload: result});
      });
  }

  canBuyCoins () {
    const address = Storage.getState().account.currentAccount;

    window.contract
      .methods
      .canBuyTokens(address)
      .call({from: address}, (err, result) => {
        Storage.dispatch({type: SET_ADDRESS_ALLOWED_TO_BUY_COINS, payload: result});
      });
  }
}



// WEBPACK FOOTER //
// ./src/utils/WalletInformationUpdaterService.js